module.exports = __webpack_public_path__ + "assets/img/16_1652_big.aa01ee65.jpg";